// eslint-disable-next-line import/no-anonymous-default-export
export default {
  OnlineScreen: 'HitPawオンライン画面録画',
  RecordScreenWithAudio:
    '画面全体、アプリケーション、ブラウザタブを音声付きで録画できます。',
  ScreenOnly: 'スクリーンのみ',
  ScreenAndCam: 'スクリーン＆Webカメラ',
  Microphone: 'マイク',
  SystemAudio: 'システム音',
  StartRecording: '録画開始',
  NoAudioAndTryAgain:
    '利用可能なオーディオソースがありません。以下の<1><0>手順</0></1>に従って、もう一度お試しください。',
  TheInstruction: '手順',
  AccessMicrophone:
    'online.hitpaw.jp は、音声を録音するためにマイクにアクセスする必要がありますので、「許可」をクリックしてください。',
  BestScreenRecorderSoftware: '最高の画面録画ソフト＆無料動画配信ソフト',
  CaptureAnythingOnScreen:
    'ウェブサイト、講義、ビデオ通話、画面上の全てをキャプチャして記録。',
  RecordToShare: 'ゲームの最高の瞬間を記録し、友人と共有',
  StreamOnFackbook: 'Facebook、YouTube、Twitchなどでプロ並みのライブ配信が可能',
  BringMagic: '仮想Webカメラでライブ配信やビデオチャットに魔法をもたらす',
  StepOne: '手順1：録画したい画面を選択します。',
  StepTwo: '手順2：録画したい画面を選択します。',
  StepThree: '手順3：「システム音の共有」をクリックします。',
  StepFour: '手順2：「共有」をクリックし、録画を開始します。',
  GrantPermission: '画面録画の許可を得て、もう一度試してください。',
  RecordingProgress: '録画中...',
  MoreOptions: 'より詳しい録画オプション：',
  Pause: '一時停止',
  Continue: '続き',
  Stop: '停止',
  Webcam: 'Webカメラ',
  GreenScreenAndChangeBackground: 'グリーンスクリーン＆背景変更',
  StreamToYouTube: 'Facebook、Twitch、YouTubeなどへのライブ配信',
  ScheduleRecording: '録画予約',
  NewRecording: '新規録画',
  ExportToMp4: 'MP4に保存',
  AddWatermark: '透かしを追加',
  ChangeSpeed: '速度変更',
  CutAndTrim: 'カット＆トリム',
  '120XDownload': '120倍速の動画変換とHD動画ダウンロードソフト',
  CovertAudioFormats: '動画・音声ファイルを1,000以上の形式に変換',
  DownloadVideoFromWebsites:
    '10000+の動画共有サイトから動画をダウンロードし保存することが可能',
  BatchConvertImageAndGif: '画像の一括変換、動画をGIFに作成',
  RichEdingingFeatures:
    'マージ、カット、クロップ、透かしなどの豊富な動画編集機能を内蔵',
  BestVideoEditor: '多目的に使える最高の動画編集ソフト',
  MakeSimpleEdits: '複雑な編集を簡単にする、数々の賞を受賞した動画編集ソフト',
  BeyondImaginationMaterials: '想像を超える多彩な内蔵・オンライン素材',
  AqualityVideoMaker:
    '1080P/4K動画を完全無料でエクスポート・共有できる品質重視の動画編集ソフト',
  WorkOnAnywhere:
    'いかなるPCでも、性能に影響を与えることなく、安全かつ良好に作業',
  RecordCompleted: '録画完了',
  Download: 'ダウンロード',
  YouMayNeed: 'お見逃しなく',
  TryItFree: '無料体験',
  AlreadyHaveAccount: '既にアカウントがありますか？',
  LoginNow: '今すぐログイン',
  exceedTenMin: '10 分間のレコーディングの時間は終了しました。',
  UpgradeToRecord: '録画を続けるにはアップグレードしてください。',
  ScreenProFeature: 'HitPawオンライン録画プロの機能を利用します。',
  FreeScreenAccount:
    '無料アカウントの録画時間は<1><0>10</0></1>分のみです。アップグレードして',
  BuyNow: '今すぐ購入',
  DownloadMp4: 'MP4としてダウンロードする',
  FreeDownload: '無料ダウンロード',
  DownloadTenMin: 'ダウンロード10分',
  FullVideo: 'フル动画',
  FormatMp4: 'MP4としてダウンロードする',
  Downloading: 'ダウンロード中…',
  DownloadFailed: 'ダウンロードに失敗しました。もう一度お試しください。',
  DownloadSuccess: 'ダウンロードに成功しました！',
  Exceed100MDownloadConvert:
    'MP4形式の動画をダウンロードする場合、動画のサイズは100MBを超えることはできません。HitPaw Video Converterをダウンロードして、より多くの機能を利用します。',
  Exceed30Min:
    'MP4形式の動画をダウンロードする場合、動画の長さは30分を超えることはできません。HitPaw Video Converterをダウンロードして、より多くの機能を利用します。',
  Week: '週',
  Month: '月',
  Year: '年',
  BilledMonthly: '月',
  BilledAnnually: '年間払い',
  ConvertText1:
    'サイズ制限のない大きなファイルを一括処理するためのデスクトップバージョンのダウンロード',
  ConvertText2:
    'ビデオファイルとオーディオファイルを120倍の速度で1000以上のフォーマットに一括変換',
  ConvertText3:
    'YouTube、TikTok、Instagramなど、10,000以上のサイトから動画をダウンロードして保存します。',
  ConvertText4: 'Apple MusicをDRMを削除するMP 3に変換（Windowsバージョンのみ）',
  TenMinUp: '10 分間のレコーディングの時間は終了しました。',
  UpgradeMore: '録画を続けるにはアップグレードしてください。',
  NoRecordLimit: '画面録画の時間制限なし',
  NoRecordNumLimit: '録画回数の制限なし',
  DownloadVideoMP4: '動画をMP4でダウンロードする',
  MonthOff: '60% OFF',
  YearOff: '80% OFF',
  UpgradeNow: '今すぐアップグレード',
  CheckConnect: 'ネットワークを確認して再試行してください。',
};
